module.exports = __webpack_public_path__ + "img/tzgg.f049a311.png";